// --- START FILE: Zod validators for inventory payloads (prevents runtime crashes on invalid responses) ---
import { z } from "zod";

// Filament option shape expected from GET /inventory/filament-options
export const filamentOptionSchema = z.object({
  inventory_id: z.number(),
  material: z.string(),
  color: z.string(),
  hex_code: z.string(),
  price_per_gram: z.number(),
  diameter: z.number(),
  density: z.number(),
});

export const filamentOptionsArraySchema = z.array(filamentOptionSchema);

/**
 * Validate payload for filament options.
 * If invalid, throws a ZodError to be handled by the caller.
 */
export function validateFilamentOptions(payload: unknown) {
  return filamentOptionsArraySchema.parse(payload);
}
// --- END FILE: Zod validators for inventory payloads (prevents runtime crashes on invalid responses) ---